module.exports = __webpack_public_path__ + "static/media/VE.e5efb1e8.png";